export const GOOGLE_MAPS_API_KEY =
  String(process.env.NODE_ENV).toUpperCase() === "PRODUCTION" ?
    "AIzaSyCnTr8R9ZxC2UYSUk3q-tGOH87srhvbOlY" :
    "AIzaSyCnTr8R9ZxC2UYSUk3q-tGOH87srhvbOlY"
export const CAPTCHA_SITE_KEY = "6LdkF0EUAAAAAKZoE_vD3lnKJIPLt613roLbW65N"
export const RELEASE = "3.5"
export const SENTRY_URL = "https://95a0afc8ae6344d4a5e2f81f44fd7c51@sentry.io/137626"



// WEBPACK FOOTER //
// ./src/constants/config.js